import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router'
import { StoresContext } from '@App/contexts'
import RootStore from '@App/stores/root-store'
import Navigation from '@App/navigation'
import './index.scss'
import OverclaimToolTip from '@Components/Tooltips/OverclaimToolTip'

interface WorkToOverclaimSubHeaderProps {
    overclaimHeaderId?: number
}

const WorkToOverclaimSubHeader = ({ overclaimHeaderId }: WorkToOverclaimSubHeaderProps) => {
    if (!overclaimHeaderId) {
        return null
    }

    const { rightsholderStore } = useContext<RootStore>(StoresContext)

    return (
        <div className="work-to-overclaim-subheader">
            <OverclaimToolTip />
            <NavLink
                to={Navigation.rightholder.overclaim.view(rightsholderStore.currentRightsholderId, overclaimHeaderId)}
                className="subheader-link"
            >
                View overclaim
            </NavLink>
        </div>
    )
}

export default observer(WorkToOverclaimSubHeader)
